module.exports = __webpack_public_path__ + "static/media/Bettair_ChartButton.abc2b69c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Bettair_ChartButton.svg
// module id = 710
// module chunks = 0